import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  border: 2px solid ${(p) => p.theme.palette.warning[600]};
  border-radius: ${(p) => p.theme.spacing(1, 1, 0, 0)};
  border-bottom: none;
  margin-right: auto;
  margin-left: auto;
`;
